import { useLanguage } from "../../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="relative font-sans">
      <div className="bg-darkBlue">
        <div className="mx-auto sm:max-w-3xl lg:max-w-screen-2xl 2xl:max-w-screen-2xl px-6 sm:px-8 lg:px-10 py-12 lg:py-20">
          <div className="xl:grid xl:grid-cols-3 xl:gap-12">
            <div className="flex flex-col lg:grid grid-flow-col auto-cols-fr gap-10 xl:col-span-2">
              <div>
                <h3 className="text-sm font-bold uppercase tracking-widest text-orange">
                  {t("footer.whyUs")}
                </h3>
                <ul className="mt-5 space-y-3">
                  <li>
                    <a
                      href="/ourCompany"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.ourCompany")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/ourMission"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.ourMission")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://sites.google.com/ipps.co.th/home-eng/home"
                      target="_blank"
                      rel="noreferrer"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("footer.disclaimer")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://sites.google.com/ipps.co.th/home-eng/privacy-policy?authuser=0"
                      target="_blank"
                      rel="noreferrer"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("footer.privacyPolicy")}
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-sm font-bold uppercase tracking-widest text-orange">
                  {t("footer.products")}
                </h3>
                <ul className="mt-5 space-y-3">
                  <li>
                    <a
                      href="/products/e-wallets"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.eWallets")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/products/virtual-account"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.virtualAccounts")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/products/invoice-QR-Integration"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.invoiceQr")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/products/treasury"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.treasury")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/products/B2B"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.b2bPayments")}
                    </a>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="text-sm font-bold uppercase tracking-widest text-orange">
                  {t("footer.solutions")}
                </h3>
                <ul className="mt-5 space-y-3">
                  <li>
                    <a
                      href="/solutions#b2b-payments"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.b2bPayments")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions#order-to-cash"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.orderToCash")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions#record-to-report"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.recordToReport")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions#cash-management"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.cashManagement")}
                    </a>
                  </li>
                  <li>
                    <a
                      href="/solutions#account-payables"
                      className="text-sm text-gray-300 hover:text-white transition-colors duration-200"
                    >
                      {t("nav.items.accountPayables")}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="mt-12 xl:mt-0">
              <h3 className="text-sm font-bold uppercase tracking-widest text-orange">
                {t("footer.stayUpdated")}
              </h3>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                {t("footer.subscribeDesc")}
              </p>
              <form className="mt-5">
                <div className="flex max-w-sm">
                  <input
                    type="email"
                    required
                    placeholder={t("footer.emailPlaceholder")}
                    className="flex-1 min-w-0 bg-white/10 border border-white/20 text-white text-sm rounded-l-xl px-4 py-3 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-orange/50 focus:border-orange transition-all duration-200"
                    autoComplete="off"
                  />
                  <button
                    type="submit"
                    className="bg-orange text-white text-sm font-semibold px-5 py-3 rounded-r-xl hover:bg-pink transition-colors duration-300 whitespace-nowrap"
                  >
                    {t("common.subscribe")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-darkBlue border-t border-white/10">
        <div className="mx-auto px-6 sm:px-8 lg:px-10 max-w-7xl py-5 flex items-center justify-center">
          <p className="text-gray-400 text-xs tracking-wide">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
